import CustomersService from 'services/customers.service';
import { actions } from './actionTypes';
import { alertActions } from '../alert.actions';

export const getListCustomers = (params?: any) => {
  return (dispatch: any) => {
    dispatch(actions.getListCustomers());
    CustomersService.getListCustomers(params)
      .then((res: any) => {
        dispatch(actions.getListCustomersSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getListCustomersFail(err));
      });
  };
};

export const getListGroups = (params?: any) => {
    return (dispatch: any) => {
      dispatch(actions.getListGroups());
      CustomersService.getListGroups(params)
        .then((res: any) => {
          dispatch(actions.getListGroupsSuccess(res?.data));
        })
        .catch((err) => {
          dispatch(actions.getListGroupsFail(err));
        });
    };
  };

  export const getListBriks = (group_id: any, params?: any) => {
    return (dispatch: any) => {
      dispatch(actions.getListBriks());
      CustomersService.getListBriks(group_id, params)
        .then((res: any) => {
          dispatch(actions.getListBriksSuccess(res?.data));
        })
        .catch((err) => {
          dispatch(actions.getListBriksFail(err));
        });
    };
  };

  export const getListMembers = (group_id: string, params?: any) => {
      return (dispatch: any) => {
        dispatch(actions.getListMembers());
        CustomersService.getListMembers(group_id, params)
          .then((res: any) => {
            dispatch(actions.getListMembersSuccess(res?.data));
          })
          .catch((err) => {
            dispatch(actions.getListMembersFail(err));
          });
      };
    };

export const getListMembersApp = (group_id: any, params?: any) => {
    return (dispatch: any) => {
      dispatch(actions.getListMembersApp());
      CustomersService.getListMembersApp(group_id, params)
        .then((res: any) => {
          dispatch(actions.getListMembersAppSuccess(res?.data));
        })
        .catch((err) => {
          dispatch(actions.getListMembersAppFail(err));
        });
    };
};

export const getUserCount = (group_id: any) => {
    return (dispatch: any) => {
      dispatch(actions.getUserCount());
      CustomersService.getUserAcount(group_id)
        .then((res: any) => {
          dispatch(actions.getUserCountSuccess(res?.data));
        })
        .catch((err) => {
          dispatch(actions.getUserCountFail(err));
        });
    };
};

export const getBrikPage = (user_id: any, brik_id: any) => {
    return (dispatch: any) => {
      dispatch(actions.getBrikPage());
      CustomersService.getBrikPage(user_id, brik_id)
        .then((res: any) => {
          dispatch(actions.getBrikPageSuccess(res?.data));
        })
        .catch((err) => {
          dispatch(actions.getBrikPageFail(err));
        });
    };
};

export const createGroup = (params: any) => {
  return (dispatch: any) => {
    dispatch(actions.createGroups());
    CustomersService.createGroup(params)
      .then((res: any) => {
        dispatch(actions.createGroupsSuccess(res?.data));
        dispatch(alertActions.success('Group has been created successfully!'));
      })
      .catch((err) => {
        dispatch(actions.createGroupsFail(err));
      });
  };
};

export const inviteMembers = (group_id: any, params: any) => {
  return (dispatch: any) => {
    dispatch(actions.inviteMembers());
    CustomersService.inviteMember(group_id, params)
      .then((res: any) => {
        dispatch(actions.inviteMembersSuccess(res));
        dispatch(alertActions.success('An invitation email has been sent!'));
      })
      .catch((err) => {
        dispatch(actions.inviteMembersFail(err));
      });
  };
};

export const inviteCustomer = (params: any) => {
  return (dispatch: any) => {
    dispatch(actions.inviteCustomer());
    CustomersService.inviteCustomer(params)
      .then((res: any) => {
        dispatch(actions.inviteCustomerSuccess(res));
        dispatch(alertActions.success('An invitation email has been sent!'));
      })
      .catch((err) => {
        dispatch(actions.inviteCustomerFail(err));
      });
  };
};

export const getListBriksAddToGroup = (group_id: any, params?: any) => {
  return (dispatch: any) => {
    dispatch(actions.getListBriksAddToGroup());
    CustomersService.getListBriksAddToGroup(group_id, params)
      .then((res: any) => {
        dispatch(actions.getListBriksAddToGroupSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getListBriksAddToGroupFail(err));
      });
  };
};

export const addBrikToGroup = (group_id: any, params?: any) => {
  return (dispatch: any) => {
    dispatch(actions.addBrikToGroup());
    CustomersService.addBrikToGroup(group_id, params)
      .then((res: any) => {
        dispatch(actions.addBrikToGroupSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.addBrikToGroupFail(err));
      });
  };
};
